// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"602":"417b5371","702":"417b5371"}[chunkId] + ".chunk.css";
};